// extracted by mini-css-extract-plugin
export default {"simpleSpinnerContainer":"SimpleSpinner_simpleSpinnerContainer__qPL6u"};